import { Button, Modal } from 'antd'
import React, { useState } from 'react'
import maruza1 from '../Components/fayl/maruza/1.pdf'
import maruza2 from '../Components/fayl/maruza/2.pdf'
import maruza3 from '../Components/fayl/maruza/3.pdf'
import maruza4 from '../Components/fayl/maruza/4.pdf'
import maruza5 from '../Components/fayl/maruza/5.pdf'
import maruza6 from '../Components/fayl/maruza/6.pdf'
import maruza7 from '../Components/fayl/maruza/7.pdf'
import maruza8 from '../Components/fayl/maruza/8.pdf'
import maruza9 from '../Components/fayl/maruza/9.pdf'
import maruza10 from '../Components/fayl/maruza/10.pdf'
import maruza11 from '../Components/fayl/maruza/11.pdf'
import maruza12 from '../Components/fayl/maruza/12.pdf'
import maruza13 from '../Components/fayl/maruza/13.pdf'
import maruza14 from '../Components/fayl/maruza/14.pdf'
import maruza15 from '../Components/fayl/maruza/15.pdf'

export const Maruza = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return (
        <div className="card " >
            <Button className='button' onClick={showModal}>
               Taqdimotlar
            </Button>
            <Modal
                className="custom-modal "
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}> <br /><hr />
                <div className='button-container'> 
                    <Button className='button'>
                        <a href={maruza1}>1-ma'ruza</a>
                    </Button>
                    <Button className='button'>
                        <a href={maruza2}>2-ma'ruza</a>
                    </Button><Button className='button'>
                        <a href={maruza3}>3-ma'ruza</a>
                    </Button><Button className='button'>
                        <a href={maruza4}>4-ma'ruza</a>
                    </Button><Button className='button'>
                        <a href={maruza5}>5-ma'ruza</a>
                    </Button><Button className='button'>
                        <a href={maruza6}>6-ma'ruza</a>
                    </Button><Button className='button'>
                        <a href={maruza7}>7-ma'ruza</a>
                    </Button><Button className='button'>
                        <a href={maruza8}>8-ma'ruza</a>
                    </Button><Button className='button'>
                        <a href={maruza9}>9-ma'ruza</a>
                    </Button><Button className='button'>
                        <a href={maruza10}>10-ma'ruza</a>
                    </Button><Button className='button'>
                        <a href={maruza11}>11-ma'ruza</a>
                    </Button><Button className='button'>
                        <a href={maruza12}>12-ma'ruza</a>
                    </Button><Button className='button'>
                        <a href={maruza13}>13-ma'ruza</a>
                    </Button><Button className='button'>
                        <a href={maruza14}>14-ma'ruza</a>
                    </Button><Button className='button'>
                        <a href={maruza15}>15-ma'ruza </a>
                    </Button>
                </div> <hr /><br />
            </Modal>
        </div>
    )
}
